import {defineNuxtPlugin} from '#app'
import vLongpress from '@/directives/v-longpress'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('longpress', vLongpress)
})
